import type { DrawerProps } from "@chakra-ui/react";
import {
	Drawer,
	DrawerBody,
	DrawerContent,
	DrawerHeader,
	DrawerOverlay,
} from "@chakra-ui/react";
import { CloseButton } from "components/RFQ/CloseButton";
import { TabHeader } from "components/TabHeader";
import SupplierForm from "pages/RFQ/SupplierList/SupplierForm";
import React from "react";

type CreateSupplierDrawerProps = {
	isOpen: boolean;
	listIDCompanies: string[]; // adjust type if different
	onClose: () => void;
} & Partial<DrawerProps>; // include additional Chakra props like `trapFocus`, etc.

const CreateSupplierDrawer: React.FC<CreateSupplierDrawerProps> = ({
	onClose,
	isOpen,
	listIDCompanies,
	...props
}) => {
	return (
		<div>
			<Drawer
				placement="right"
				isOpen={isOpen}
				onClose={onClose}
				size="xl"
				{...props}
			>
				<DrawerOverlay onClick={onClose} />
				<DrawerContent>
					<DrawerHeader
						borderBottomWidth="1px"
						className="px-0 py-6 text-black"
					>
						<div className="mx-6">
							<TabHeader
								noDivider
								heading="CREATE NEW SUPPLIER LIST"
								description="Add shortlisted companies to a new supplier list."
							>
								<CloseButton onClose={onClose} />
							</TabHeader>
						</div>
					</DrawerHeader>
					<DrawerBody className="max-h-[calc(100vh - 100px)] p-6">
						<SupplierForm
							isNew
							isEdit={false}
							listId=""
							isAddSupplier
							listIDCompanies={listIDCompanies}
							closeDialog={onClose}
						/>
					</DrawerBody>
				</DrawerContent>
			</Drawer>
		</div>
	);
};

export default CreateSupplierDrawer;
